import React from 'react';
export const statusFilceIcon = {
  1: 'icon-file-empty',
  2: 'icon-file-empty',
  3: 'icon-file-check',
  4: 'icon-file-empty',
  5: 'icon-file-empty'
};
export function Status({ statusID }) {
  const statusColor = {
    1: 'tag-color-gray',
    2: 'tag-color-blue',
    3: 'tag-color-green',
    4: 'tag-color-red',
    5: 'tag-color-gray'
  };
  const statusName = { 1: 'Bíður vinnslu', 2: 'í vinnslu', 3: 'Samþykkt', 4: 'Hafnað', 5: 'Í bið' };
  const statusIcon = {
    1: 'icon-checkmark-circle2',
    2: 'icon-checkmark-circle2',
    3: 'icon-stop',
    4: 'icon-pause',
    5: 'icon-pause'
  };
  return <span className={`tag ${statusColor[statusID]} `}>{statusName[statusID]}</span>;
}
